var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.034,
    height: 128,
    viewBox: "0 0 128.034 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M84.2,69.017l45.729-45.729A10.715,10.715,0,0,0,114.778,8.135L69.049,53.864,23.321,8.135A10.715,10.715,0,1,0,8.167,23.289L53.9,69.017,8.167,114.746A10.715,10.715,0,0,0,23.321,129.9L69.049,84.171,114.778,129.9a10.715,10.715,0,1,0,15.153-15.153Z",
    transform: "translate(-5.016 -5.017)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c158c5e21604e71ae28baccde21295de.svg";
export { ForwardRef as ReactComponent };